<template>
	<v-container fluid>
		<div class="d-flex flex-wrap py-2">
			<v-btn class="ma-1" color="primary" small @click="getImpagados">
				<v-icon left>mdi-reload</v-icon>Recargar
			</v-btn>
			<v-btn class="ma-1" color="primary" small @click="porcentajesDialog = true">
				<v-icon left>mdi-percent</v-icon>Porcentajes por comercial
			</v-btn>
			<v-spacer />
			<download-csv
				:data="selected"
				:name="`control_impagados_${new Date().getTime()}.csv`"
				delimiter=";"
				ref="descargarBtn"
				v-if="$root.acceso('CONTROL_IMPAGADOS')"
			>
				<v-btn text class="ma-1" color="primary" small :disabled="selected.length == 0">
					<v-icon left>mdi-download</v-icon>Descargar seleccionados
				</v-btn>
			</download-csv>
		</div>
		<v-card>
			<v-data-table
				fixed-header
				:items="impagados"
				:headers="impagadosHeader"
				show-select
				item-key="IdCarteraCobro"
				v-model="selected"
				:single-select="false"
				:calculate-widths="true"
				:search="search"
				:loading="loading"
				:footer-props="{
					showFirstLastPage: true,
					showCurrentPage: true,
					itemsPerPageOptions: [10, 25, 50],
				}"
				checkbox-color="secondary"
			>
				<template v-slot:body.prepend="{ headers }">
					<table-filters :headers="headers" :items="impagados" v-model="inlineFilters"></table-filters>
				</template>

				<template v-slot:item.estado="{ item }">
					<!-- {{ [item.IdCarteraCobro, item.IdFacturaVentaCabecera] }} -->
					<status-chip :value="(item.estado)" />
				</template>
				<template v-slot:item.estadoPropio="{ item }">
					<status-chip v-if="item.estadoPropio" :value="(item.estadoPropio)" />
				</template>
				<template v-slot:item.estadoPropioFecha="{ item }">
					<span v-if="item.estadoPropioFecha" v-text="timeAgo(item.estadoPropioFecha)" />
				</template>

				<template v-slot:item.CanalAgente="{ item }">
					{{ item.CanalAgente }}
					<v-chip class="ml-2" small>
						<v-icon rigth small>mdi-percent</v-icon>
						<span class="ml-1">{{ parseFloat(porcentajes[item.CanalAgente]).toFixed(2) }}</span>
					</v-chip>
				</template>

				<template v-slot:item.FechaFactura="{ item }">
					<span v-text="parseDate(item.FechaFactura)"></span>
				</template>
				<template v-slot:item.fechaCreacion="{ item }">
					<span v-text="parseDate(item.fechaCreacion)"></span>
				</template>
				<template v-slot:item.FechaLecturaAnteriorXML="{ item }">
					<span v-text="parseDate(item.FechaLecturaAnteriorXML)"></span>
				</template>
				<template v-slot:item.FechaLecturaActualXML="{ item }">
					<span v-text="parseDate(item.FechaLecturaActualXML)"></span>
				</template>
				<template v-slot:item.FechaImpagado="{ item }">
					<span v-text="parseDate(item.FechaImpagado)"></span>
				</template>

				<template v-slot:item.ImporteBase="{ item }">
					<span v-text="parseFloat(item.ImporteBase).toFixed(2) + ' €'" />
				</template>
				<template v-slot:item.ImporteImpuesto="{ item }">
					<span v-text="`${parseFloat(item.ImporteImpuesto).toFixed(2)} €`" />
					&nbsp;
					<code>({{ item.PorcentajeImpuesto * 1 }}%)</code>
				</template>
				<template v-slot:item.ImporteTotal="{ item }">
					<span class="font-weight-bold" v-text="parseFloat(item.ImporteTotal).toFixed(2) + ' €'" />
				</template>

				<template v-slot:item.NumeroFactura="{ item }">
					<v-tooltip bottom v-if="item.IdDocumento">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								v-on="on"
								v-bind="attrs"
								link
								@click="verPDFfactura(item.IdDocumento)"
								color="secondary"
								text
								:loading="pdfId === item.IdDocumento"
								:disabled="!!pdfId"
							>
								{{ item.SerieFactura }} {{ item.NumeroFactura }}
								<v-icon right>mdi-file-pdf</v-icon>
							</v-btn>
						</template>
						<span>Ver PDF factura</span>
					</v-tooltip>
					<span
						v-else-if="item.NumeroFactura"
						link
						color="secondary"
						text
						class="text-button secondary--text"
					>{{ item.SerieFactura }} {{ item.NumeroFactura }}</span>
				</template>

				<template v-slot:item.CodigoContrato="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								v-on="on"
								v-bind="attrs"
								link
								:to="`/detalles_contrato?codigoContrato=${item.CodigoContrato}&idContrato=${item.IdContrato}`"
								color="secondary"
								text
							>{{ item.CodigoContrato }}</v-btn>
						</template>
						<span>Detalles del contrato</span>
					</v-tooltip>
				</template>

				<template v-slot:item.Identificador="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								v-on="on"
								v-bind="attrs"
								link
								:to="`/detalles_cliente?idCliente=${item.IdCliente}`"
								color="secondary"
								text
							>{{ item.Identificador }}</v-btn>
						</template>
						<span>Detalles del cliente</span>
					</v-tooltip>
				</template>

				<template v-slot:item.acciones="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								v-on="on"
								v-bind="attrs"
								@click="tab = 0; detailsId = item.IdCarteraCobro"
								icon
								color="secondary"
							>
								<v-icon>mdi-eye</v-icon>
							</v-btn>
						</template>
						Ver detalles
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn class="ml-2" color="primary" icon @click="tab = 1; detailsId = item.IdCarteraCobro">
								<v-badge :value="Number(item.nLlamadas)" :content="item.nLlamadas" overlap>
									<v-icon v-on="on" v-bind="attrs">mdi-phone</v-icon>
								</v-badge>
							</v-btn>
						</template>
						Nº Llamadas
					</v-tooltip>
				</template>
			</v-data-table>
		</v-card>

		<div class="d-flex flex-wrap mt-4 align-center">
			<strong
				class="mr-2"
			>Total importes {{ selected.length == 0 ? 'registros filtrados' : 'registros seleccionados' }} :</strong>
			{{ acumuladoImpagados }}
			<v-btn
				text
				color="primary"
				class="ml-2"
				small
				:disabled="selected.length == 0"
				@click="selected = []"
			>Deseleccionar todos ({{ selected.length }})</v-btn>
		</div>

		<v-dialog v-model="porcentajesDialog" max-width="800px">
			<v-card class="pa-2">
				<v-btn class="ma-2" small text
					@click="porcentajesSortedWay === 'max-min' ? porcentajesSortedWay = 'min-max' : porcentajesSortedWay = 'max-min'"
				>
					<v-subheader>Canales</v-subheader>
					<v-icon right small>{{ porcentajesSortedWay === 'max-min' ? 'mdi-arrow-down' : 'mdi-arrow-up' }}</v-icon>
				</v-btn>
				<v-divider></v-divider>
				<v-list dense>
					<v-list-item v-for="([canal, pc]) in porcentajesSorted" :key="canal">
						<v-list-item-content>
							<v-list-item-title class="mb-1">{{ canal }}</v-list-item-title>
							<v-progress-linear rounded height="8" max="100" :value="pc" color="secondary"></v-progress-linear>
						</v-list-item-content>
						<v-list-item-action>
							<v-chip class="ml-2" small>
								<v-icon rigth small>mdi-percent</v-icon>
								<span class="ml-1">{{ parseFloat(pc).toFixed(2) }}</span>
							</v-chip>
						</v-list-item-action>
					</v-list-item>
				</v-list>
			</v-card>
		</v-dialog>

		<v-dialog
			:value="detailsId"
			@input="(v) => v === false ? detailsId = null : null"
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
		>
			<v-card>
				<v-toolbar color="primary">
					<v-toolbar-title class="white--text">Detalles impago Cod {{ detailsId }}</v-toolbar-title>
					<v-spacer></v-spacer>

					<v-btn color="white" icon @click="detailsId = null">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar>

				<v-tabs v-model="tab">
					<v-tab v-if="$root.acceso('CONTROL_IMPAGADOS')">Control impago</v-tab>
					<v-tab v-if="$root.acceso('CONTROL_IMPAGADOS')">Histórico llamadas</v-tab>
					<v-tab>Detalles factura</v-tab>
				</v-tabs>

				<v-tabs-items v-model="tab">
					<v-tab-item>
						<detalles-impagados
							@close="detailsId = null"
							:IdCarteraCobro="detailsId"
							v-if="detailsId"
							:key="detailsId"
						/>
					</v-tab-item>
					<v-tab-item>
						<historico-llamadas
							@close="detailsId = null"
							:IdCarteraCobro="detailsId"
							v-if="detailsId"
							:key="detailsId"
						/>
					</v-tab-item>
					<v-tab-item>
						<detalles-factura
							@close="detailsId = null"
							:idFactura="idCabeceraAux"
							v-if="idCabeceraAux"
							:key="idCabeceraAux"
						/>
					</v-tab-item>
				</v-tabs-items>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import { getSituacionIcon, perColumnFilter, parseDate, downloadFile, timeAgo } from "@/utils/index.js";

export default {
	components: {
		StatusChip: () => import("@/components/StatusChip.vue"),
		TableFilters: () => import("@/components/TableFilters.vue"),
		DetallesFactura: () => import("@/views/facturacionContratos/DetallesFactura.vue"),
		DetallesImpagados: () => import("@/views/impagados/DetallesImpagados.vue"),
		HistoricoLlamadas: () => import("@/views/impagados/HistoricoLlamadas.vue"),
	},
	props: ['codigoContrato'],
	computed: {
		idCabeceraAux() {
			return (this.impagados.find(x => x.IdCarteraCobro == this.detailsId) || {}).IdFacturaVentaCabecera
		},
		acumuladoImpagados() {
			if (this.selected.length) {
				return parseFloat(this.selected.reduce((a, c) => a + Number(c.ImporteTotal), 0)).toFixed(2) + ' €'
			} else {
				// return parseFloat(this.impagados.reduce((a, c) => a + Number(c.ImporteTotal), 0)).toFixed(2) + ' €'
				const getDatatype = (key) =>
					(this.impagadosHeader.find((h) => h.value == key) || {}).dataType;

				return parseFloat(this.impagados.filter((con) =>
					Object.entries(con).every(([key, value]) =>
						perColumnFilter(value, this.inlineFilters[key], getDatatype(key))
					)
				).map(i => Number(i.ImporteTotal)).reduce((a, c) => a + c, 0)).toFixed(2) + ' €'
			}
		},
		porcentajesSorted() {
			const sort = (a, b) => this.porcentajesSortedWay === 'max-min' ? a < b ? 1 : -1 : a > b ? 1 : -1;
			return Object.entries(this.porcentajes).sort(([, p1], [, p2]) => sort(p1, p2))
		}
	},
	data() {
		return {
			debounce: true,
			loading: true,
			page: 2,
			tab: 0,
			selected: [],
			search: null,
			detailsId: null,
			llamadasId: null,
			pdfId: false,
			addImpagado: false,
			impagados: [],
			impagadosHeader: [
				{ text: 'Estado', value: 'estado', dataType: 'select' },
				{ text: 'Estado (propio)', value: 'estadoPropio', dataType: 'select' },
				{ text: 'Último cambio estado', value: 'estadoPropioFecha', dataType: 'date' },
				{ text: 'Acciones', value: 'acciones', sortable: false, filterable: false },
				{ text: 'Agente/Canal', value: 'CanalAgente' },
				{ text: 'SubAgente', value: 'SubAgente' },
				{ text: "Importe base", value: "ImporteBase" },
				{ text: "Importe Impuesto", value: "ImporteImpuesto" },
				{ text: "Total", value: "ImporteTotal" },
				{ text: "Fecha Impagado", value: "FechaImpagado", dataType: 'date' },
				{ text: 'Canal', value: 'Canal', dataType: 'select' },
				{ text: 'NºDoc', value: 'NumeroFactura' },
				{ text: 'Contrato', value: 'CodigoContrato' },
				{ text: 'Identificador', value: 'Identificador' },
				{ text: 'Cliente', value: 'denominacion' },
				{ text: 'Fecha factura', value: 'FechaFactura', dataType: 'date' },
				{ text: "Lectura Anterior", dataType: 'date', value: "FechaLecturaAnteriorXML" },
				{ text: "Fecha Lectura", dataType: 'date', value: "FechaLecturaActualXML" },
				{ text: "Motivo", value: "motivoImpagado" },
			].map((header) =>
			({
				class: "text-no-wrap sticky-header",
				cellClass: "pa-2 text-no-wrap",
				filter: (value) =>
					perColumnFilter(
						value,
						this.inlineFilters[header.value],
						header.dataType
					),
				dataType: "text",
				...header,
			})
			),


			inlineFilters: {},
			comboboxes: {},
			loadingPDF: null,
			porcentajes: {},
			porcentajesDialog: false,
			porcentajesSortedWay: 'max-min'
		};
	},
	methods: {
		getSituacionIcon,
		parseDate,
		timeAgo,
		async getImpagados() {
			this.loading = true;
			const { data: impagados } = await axios({ url: `${process.env.VUE_APP_OUR_API_URL}/impagados.php`, method: 'GET', params: { token: this.$store.getters.getJwtEmpresa, } });
			this.porcentajes = {};
			this.impagados = impagados.map(f => {
				switch (Number(f.CodigoSituacionCobro)) {
					case 0: f.estado = 'Sin Especificar'; break;
					case 1: f.estado = 'Pendiente'; break;
					case 2: f.estado = 'Cobrado'; break;
					case 3: f.estado = 'Impagado'; break;
					case 4: f.estado = 'Remesado'; break;
					case 5: f.estado = 'Carta Aviso'; break;
					case 6: f.estado = 'Carta Corte'; break;
					case 7: f.estado = 'Cortado'; break;
					case 8: f.estado = 'Cobrado norma 57'; break;
					case 9: f.estado = 'Cancelado por abono'; break;
					case 10: f.estado = 'Carta Corte 1'; break;
					case 11: f.estado = 'Carta Deuda'; break;
					case 12: f.estado = 'Fraccionado'; break;
				}

				f.denominacion = f.RazonSocialTitular ||
					[f.NombreTitular, f.Apellido1Titular, f.Apellido2Titular]
						.filter((i) => !!i)
						.join(" ");

				this.porcentajes[f.CanalAgente] = (this.porcentajes[f.CanalAgente] || 0) + 1;

				return f;
			});

			Object.entries(this.porcentajes).forEach(([key, value]) => {
				this.porcentajes[key] = value * 100 / impagados.length;
			})

			this.loading = false;
		},
		enviarImpagado(idFactura) {
			axios({
				url: `${process.env.VUE_APP_OUR_API_URL}/impagados.php`,
				method: 'POST',
				data: { token: this.$store.getters.getJwtEmpresa, idFactura }
			}).then(res => { this.addImpagado = false; this.getImpagados() })
		},
		verPDFfactura(idDocumento) {
			this.pdfId = idDocumento
			let str = this.$store.getters.getDatosEmpresa;
			const { IdUsuario } = str.iss;
			const IdEmpresa = this.$store.getters.getIdEmpresa;
			axios({
				method: "get",
				url: `${process.env.VUE_APP_API_URL}/FacturaVentaCabecera/FacturaPreviewPDF/Empresa/${IdEmpresa}/Usuario/${IdUsuario}/Documento/${idDocumento}`,
				responseType: "blob",
			})
				.then((res) => {
					let pdf = new File(
						[res.data],
						`factura_${new Date().getTime()}.pdf`,
						{
							type: "application/pdf",
						}
					);
					downloadFile(pdf, true);
					this.pdfId = null
				})
				.catch((err) => {
					this.$root.$emit("snack", "Ha ocurrido un error");
					this.pdfId = null
				});
		},
	},
	mounted() {
		this.getImpagados();
	},
};
</script>

<style scoped>
.v-data-table /deep/ [role="columnheader"] {
	/* background: #f1f1f1 !important; */
}
</style>
